import { Component, Input, forwardRef } from '@angular/core';
import { FormBuilder, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';

const regexUrl =
  /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;

@Component({
  selector: 'app-upload-flip-element',
  templateUrl: './upload-flip-element.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => UploadFlipElementComponent),
    },
  ],
  standalone: false,
})
export class UploadFlipElementComponent {
  @Input() public submitted = false;
  public form = this.formBuilder.group({
    id: undefined,
    hash: ['hash', [Validators.required]],
    flip: [undefined, [Validators.required, Validators.pattern(regexUrl), Validators.maxLength(255)]],
  });

  constructor(private formBuilder: FormBuilder) {}

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public writeValue(data: any): void {
    if (!!data) {
      this.form.patchValue(data);
    } else {
      this.form.reset();
    }
  }

  public onSend(): void {
    this.onTouched();
    this.form.get('hash').setValue('hash');
    if (this.form.valid) {
      this.onChange(this.form.value);
    } else {
      this.onChange(undefined);
    }
  }

  public onTouched = () => true;
  private onChange = (_: any) => true;
}
